import React, { useCallback, useContext, useRef } from 'react';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePromptFormAction } from '../PromptForm/usePromptFormAction';
import PromptTextArea from '../PromptForm/PromptInput/lego/PromptTextArea';
import PromptSubmitButton from '../PromptForm/PromptInput/lego/PromptSubmitButton';
import ArtStyleSlider from '../PromptForm/SettingsPanel/ArtStyleField/ArtStyleSlider';
import s from './IngressPromptForm.scss';

export interface Props {
  hideArtStyle?: boolean;
}

/**
 * A simplified form meant to drive traffic into dreamup. Values input here will carry over into dreamup on submit
 */
const IngressPromptForm: React.FC<Props> = ({ hideArtStyle }) => {
  const isMobile = useContext(MobileContext);

  const [handleSubmit, formAction] = usePromptFormAction(true);
  const submitButtonRef = useRef<HTMLButtonElement>(null);
  const handleKeyDown: React.KeyboardEventHandler<HTMLTextAreaElement> = useCallback(
    e => {
      if (e.key === 'Enter') {
        if (submitButtonRef.current) {
          submitButtonRef.current.click();
        }
        e.preventDefault();
      }
    },
    [submitButtonRef]
  );

  return (
    <form className={s['root']} onSubmit={handleSubmit}>
      <ThemeOverride theme={ThemeOptions.LIGHT}>
        <div className={s['text-input-and-button']}>
          <PromptTextArea
            formAction={formAction}
            onKeyDown={handleKeyDown}
            minRows={isMobile ? 2 : 1}
          />
          {!isMobile && <PromptSubmitButton formAction={formAction} ref={submitButtonRef} />}
        </div>
      </ThemeOverride>

      {!hideArtStyle && <ArtStyleSlider gradient="primary" />}
      {isMobile && <PromptSubmitButton formAction={formAction} ref={submitButtonRef} />}
    </form>
  );
};

IngressPromptForm.displayName = 'IngressPromptForm';

export default IngressPromptForm;
